<template>
  <el-container style="height:100vh;">
    <el-aside width="220px" class="aside">
      <div class="logo">智能回收箱 · WMS</div>

      <el-menu
        :default-active="$route.path"
        router
        background-color="#0f172a"
        text-color="#cbd5e1"
        active-text-color="#60a5fa"
      >
        <el-menu-item index="/home">首页</el-menu-item>
        <el-menu-item index="/dashboard">车辆轨迹</el-menu-item>
        <el-menu-item index="/device/list">设备管理</el-menu-item>
        <el-menu-item index="/vehicle/list">车辆管理</el-menu-item>
        <el-menu-item index="/weigh/audit">过磅审核</el-menu-item>
        <el-menu-item index="/report/collect-summary">小区清运统计</el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="header">
        <div class="title">{{ title }}</div>
        <div class="right">
          <span class="user">{{ realname }}</span>
          <el-button type="text" @click="logout">退出</el-button>
        </div>
      </el-header>

      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  computed: {
    title() {
      return (this.$route.meta && this.$route.meta.title) || '智能回收箱后台'
    },
    realname() {
      try {
        const info = JSON.parse(localStorage.getItem('admin_info') || '{}')
        return info.realname || info.name || info.username || '管理员'
      } catch (e) {
        return '管理员'
      }
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('access_token')
      localStorage.removeItem('admin_info')
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.aside {
  background: #0f172a;
}

.logo {
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  color: #fff;
  font-weight: 700;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.main {
  background: #f5f7fb;
}

.title {
  font-weight: 700;
}

.right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user {
  color: #334155;
}
</style>